// components/GoogleMapComponent.tsx
import React, { useState, useCallback, useRef } from "react";
import { GoogleMap } from "@react-google-maps/api";
import "./index.css";
import SkeletonLoader from "../SkeletonLoader";
import { useGoogleMaps } from "../../providers/GoogleMapProvider";
import { useTranslation } from "react-i18next";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const mapOptions: google.maps.MapOptions = {
  fullscreenControl: false,
  cameraControl: false,
  zoomControl: true,
};

// Interface for props
interface IMapsProps {
  onSetData: any;
  setAddress: any;
  mapCenter: any;
  storeName: any;
  setCurrentLocation: any;
  onPopupBtnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  // storesList: any[];
}

const GoogleMapComponent = ({
  onSetData,
  setAddress,
  mapCenter,
  storeName,
  setCurrentLocation,
  onPopupBtnClick,
}: // storesList,
IMapsProps) => {
  const [infoVisible, setInfoVisible] = useState(true);
  const [isMapReady, setIsMapReady] = useState(false);
  const mapRef = useRef<google.maps.Map | null>(null);
  const { isLoaded } = useGoogleMaps();
  const { t } = useTranslation();
  // const [kmlPaths, setKmlPaths] = useState([]);
  // useEffect(() => {
  //   let kml: any = [];
  //   for (let i = 0; i < storesList.length; i++) {
  //     if (
  //       storesList[i] &&
  //       storesList[i].trade_zone_id &&
  //       storesList[i].trade_zone_id.zone_json
  //     ) {
  //       kml.push(JSON.parse(storesList[i].trade_zone_id.zone_json));
  //     }
  //   }
  //   setKmlPaths(kml);
  // }, []);

  const setSelectedLocation = (center: any) => {
    // Initialize the Geocoder
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      {
        location: center,
      },
      (results: any, status) => {
        if (status === "OK" && results[0]) {
          setAddress(results[0].formatted_address);
          const obj = {
            lat: center.lat,
            lng: center.lng,
            address: results[0].formatted_address,
          };
          onSetData(obj);
        } else {
          console.error("Geocoding failed:", status);
        }
      }
    );
  };
  // Function to handle center change and retrieve the address
  const handleCenterChanged = useCallback(() => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      const lat = newCenter?.lat();
      const lng = newCenter?.lng();
      if (lat && lng) {
        // Initialize the Geocoder
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results: any, status) => {
          if (status === "OK" && results[0]) {
            setAddress(results[0].formatted_address);
            const obj = {
              lat: lat,
              lng: lng,
              address: results[0].formatted_address,
            };
            onSetData(obj);
          } else {
            console.error("Geocoding failed:", status);
          }
        });
      }
    }
  }, []);

  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
    // const center = {
    //   // fourways mall
    //   lat: -24.2553041,
    //   lng: 34.7070491,
    // };
    // const center = {
    //   lat: 25.2777856, // Default QAT latitude
    //   lng: 51.4705438, // Default QAT latitude
    // };
    mapCenter ? setSelectedLocation(mapCenter) : setCurrentLocation(); //It's due to only testing,
  }, []);

  if (!isLoaded) return <SkeletonLoader />;

  const getMarkerInfo = () => {
    if (storeName) return <h6>{storeName}</h6>;

    if (onPopupBtnClick) {
      return (
        <button className="noDeliveryBtn" onClick={onPopupBtnClick}>{t("DONOTDELIVER")}</button>
      );
    }

    return "No store found";
  };

  return (
    <div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={12}
        options={mapOptions}
        onLoad={onLoad}
        onTilesLoaded={() => setIsMapReady(true)}
        onDragEnd={handleCenterChanged}
      >
        {/* Render each zone as a Polygon */}
        {/* {kmlPaths.map((zone: any, index: number) => (
          <Polygon
            key={index}
            paths={zone.map((point: any) => ({
              lat: parseFloat(point.lat),
              lng: parseFloat(point.lng),
            }))}
            options={{
              fillColor: "#c8102e",
              fillOpacity: 0.35,
              strokeColor: "#c8102e",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              clickable: false,
              draggable: false,
              editable: false,
              geodesic: false,
              zIndex: 1,
            }}
          />
        ))} */}
        {isMapReady && (
          <>
            <div
              className="pinIcon"
              onClick={() => setInfoVisible(!infoVisible)} // Toggle info window
            >
              <img
                src="/pin-red.png" // Replace with your marker image
                alt="Center Marker"
                style={{ width: "30px", height: "40px" }}
              />
            </div>
            {/* Info Window */}
            {infoVisible && (
              <div className="infoWindowContent">{getMarkerInfo()}</div>
            )}
          </>
        )}
      </GoogleMap>
    </div>
  );
};

export default GoogleMapComponent;
